<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-title>
              <v-col cols="12" class="py-0">
                <span class="text-h6">Total companies count ({{ count }})</span>
              </v-col>
              <vs-button
                class="mx-2 text-caption"
                color="#6c5dd4"
                to="/companies/create"
                >+ Add Company</vs-button
              >
              <v-spacer></v-spacer>
              <vs-pagination
                v-model="page"
                color="#6c5dd4"
                :length="paginationLength"
              >
              </vs-pagination>
              <vs-input
                class="search-field-input text-caption"
                v-model="search_keyword"
                placeholder="Search ... "
                prepend-inner-icon="mdi-magnify"
                @keydown.enter="getData"
                @change="page = 1"
                clearable
              ></vs-input>
              <vs-button
                v-if="companies.length != 0"
                color="#6c5dd4"
                class="rounded-lg text-caption"
                :class="$vuetify.breakpoint.smAndDown ? 'ml-5' : ''"
                :loading="isExcelLoading"
                @click="generateExcel()"
              >
                Generate Excel</vs-button
              >
            </v-card-title>
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="#6c5dd4"
            ></v-progress-linear>
            <v-simple-table fixed-header height="600">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Logo</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Contact Person</th>
                    <th class="text-left">Phone</th>
                    <th class="text-left">Address 1</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody v-if="companies.length != 0">
                  <tr v-for="(company, i) in companies" :key="company.name">
                    <td style="min-width: 85px">
                      <v-tooltip bottom v-if="company.is_active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="green"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>Company is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="company.is_active == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>Company is InActive</span>
                      </v-tooltip>
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td>
                      <v-img
                        :src="mediaUrl + company.logo_path"
                        width="40"
                        height="40"
                        class="rounded-circle"
                      />
                    </td>
                    <td>{{ company.name || "" }}</td>
                    <td>{{ company.email || "" }}</td>
                    <td>{{ company.contact_person || "" }}</td>
                    <td>{{ company.phone || "" }}</td>
                    <td>
                      {{ company.address_1 || "" }}
                    </td>
                    <td class="text-center">
                      <div class="text-center">
                        <v-menu stransition="slide-x-transition" bottom left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="white"
                              class="px-0"
                              min-width="21"
                              height="29"
                              elevation="1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item :to="`/companies/${company.id}`">
                              <v-list-item-title class="text-caption"
                                >Edit Company</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              @click="generatereportsExcel(company.id)"
                            >
                              <v-list-item-title class="text-caption"
                                >Export Data</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="7" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "companiesPage",
  data() {
    return {
      form: {
        is_active: "",
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      companies: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      isLoading: false,
      isExcelLoading: false,
      isReportExcelLoading: false,
      ExportCompanies: [],
      Export_companies: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Email: "email",
        "Contact Person": "contact_person",
        Phone: "phone",
        Address: "address",
        "Is Active": "status",
      },
    };
  },
  watch: {
    page: "getData",
  },
  computed: {
    companyId() {
      if (this.roleName === "Super Admin") {
        return this.$store.getters["settings/getCompanyId"];
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let companies = [];
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.is_active;
      companies = await axios.get(`companies?${query}`);
      this.companies = companies.data.data;
      this.count = companies.data.count;
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },

    async generateExcel() {
      this.isExcelLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.is_active;
      try {
        let response = await axios.get(`companiesExports?${query}`);
        if (response && response.data && response.data.data) {
          this.isExcelLoading = false;
          window.open(`${response.data.data}`, "_blank");
        } else {
          console.error("Invalid response data:", response.data);
          this.isExcelLoading = false;
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
        this.isExcelLoading = false;
      }
    },
    async generatereportsExcel(CompanyId) {
      this.isReportExcelLoading = true;
      try {
        const config = {
          headers: {
            "Company-id": CompanyId,
          },
        };
        let response = await axios.get(`unitsExport`, config);
        if (response && response.data && response.data.data) {
          this.isReportExcelLoading = false;
          window.open(`${response.data.data}`, "_blank");
        } else {
          console.error("Invalid response data:", response.data);
          this.isReportExcelLoading = false;
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
        this.isReportExcelLoading = false;
      }
    },
    // async SendMail(id, type = "SCHOOL") {
    //   this.sending_mail = true;
    //   let is_mail_sent = "";
    //   if (type == "SCHOOL") {
    //     let query = "school_id=" + id;
    //     is_mail_sent = await axios.get(`/companies/send_mail?${query}`);
    //   } else {
    //     let query = "user_id=" + id;
    //     is_mail_sent = await axios.get(`/users/send_mail?${query}`);
    //   }
    //   if (is_mail_sent) {
    //     this.sending_mail = false;
    //     this.is_Mail_Sent = true;
    //     this.getData();
    //   }
    // },
  },
};
</script>
